import dayjs from 'dayjs';

import type {CourseExpandedCommon} from '../../../api/course';
import type {Nullable} from '../../utility-types';

import {datetimeObjToISOString} from '../../datetime';
import {envManager} from '../../env';
import {isCourseCorporate, isCourseEvergreen} from '../course';
import {EVERGREEN_PROGRAM_SCHEDULE_DURATION} from '../program';

export const getSubgoalMinMaxDates = (
  course?: Nullable<CourseExpandedCommon>,
) => {
  const minDate = dayjs(
    course?.start_date ? datetimeObjToISOString(course.start_date) : undefined,
  ).toDate();

  // course end date or fallback to today
  const courseEndDateDjs = dayjs(
    course?.end_date ? datetimeObjToISOString(course.end_date) : undefined,
  );

  let maxDate = course?.end_date
    ? courseEndDateDjs.toDate()
    : dayjs()
        .add((course?.edition || {duration: 7}).duration, 'day')
        .toDate();

  if (isCourseCorporate(course)) {
    const defaultDaysLimit = 90;

    const dayLimit =
      course?.subtenant?.limits?.subgoal_creation_days || defaultDaysLimit;

    maxDate = courseEndDateDjs.add(dayLimit, 'days').toDate();
  } else if (envManager.isCore) {
    if (isCourseEvergreen(course)) {
      maxDate = dayjs()
        .add(EVERGREEN_PROGRAM_SCHEDULE_DURATION, 'day')
        .toDate();
    }
  }

  /**
   * Be careful if you want to change the return value shape
   * It's passed directly to components
   */
  return {
    maxDate,
    minDate,
  };
};
